const FORM_ENDPOINT_BASE = 'https://app.thecustomproductbuilder.com/forms';            // production
// const FORM_ENDPOINT_BASE = 'https://app-develop.thecustomproductbuilder.com/forms'; // develop
// const FORM_ENDPOINT_BASE = 'https://app-stage.thecustomproductbuilder.com/forms';   // stage

const tokenRequests = new WeakMap();

export function primeLeadToken(form, formType) {
    const request = () => {
        if (tokenRequests.has(form)) return;

        tokenRequests.set(
            form,
            fetch(`${FORM_ENDPOINT_BASE}/${formType}/token`, { credentials: 'omit' })
                .then((response) => (response.ok ? response.json() : null))
                .then((body) => (body && body.token) || '')
                .catch(() => ''),
        );
    };

    // input/change, not focus/click: the footer subscribe form is on every page, so
    // focus would mint a token for anyone who merely tabs past it.
    ['input', 'change'].forEach((event) => {
        form.addEventListener(event, request, { once: true });
    });
}

export function submitLead(formType, fields = {}, form = null) {
    const pending = form && tokenRequests.has(form) ? tokenRequests.get(form) : Promise.resolve('');

    return pending
        .then((token) => fetch(`${FORM_ENDPOINT_BASE}/${formType}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                page: window.location.pathname,
                referrer: document.referrer,
                utm: collectUtm(),
                website: fields.website || '', // honeypot — must stay empty for humans
                token,
                ...fields,
            }),
        }))
        .then((response) => {
            if (!response.ok) {
                throw new Error(`[CPB:lead] Relay responded ${response.status}`);
            }
            // 204 is the honeypot drop — reads as success to the client, but is not a lead.
            if (response.status !== 204 && typeof window.oaiq === 'function') {
                try {
                    window.oaiq('measure', 'lead_submitted', {
                        type: 'customer_action',
                        amount: 0,
                        currency: 'USD',
                    });
                } catch (err) {
                    console.warn('[CPB:lead] OpenAI Ads conversion failed', err);
                }
            }
            return response;
        });
}

function collectUtm() {
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach((key) => {
        const value = params.get(key);
        if (value) utm[key] = value;
    });
    return utm;
}
